import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormlyRenewalComponent} from './renewal.component';
import {FormlyModule} from '@ngx-formly/core';
import {I18nModule} from '@spartacus/core';
import {IconButtonTooltipComponent} from '@dcp/configurator';
import {ReactiveFormsModule} from '@angular/forms';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    I18nModule,
    CommonModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'renewal',
          component: FormlyRenewalComponent,
        },
      ],
    }),
    IconButtonTooltipComponent,
    ReactiveFormsModule,
    FormlyRenewalComponent,
  ],
})
export class FormlyRenewalModule {}
